const CptName = 'ComOrderLine'
function formatData (node) {
  // console.dir(node);
  return {
    data: {
      children: []
    },
    cpt: CptName
  }
}

export default {
  name: 'order_list',
  formatData,
}